@if (open && config) {
<div class="perfil-documento-modal" [class.perfil-documento-modal--single]="isSingleLayout"
  [class.perfil-documento-modal--no-samples]="!hasSamples" role="dialog" aria-modal="true"
  aria-labelledby="perfil-documento-modal-title" (click)="onBackdrop($event)">
  <div class="perfil-documento-modal__panel" (click)="$event.stopPropagation()">
    <button type="button" class="perfil-documento-modal__close" aria-label="Cerrar" (click)="onClose()">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>

    <div class="perfil-documento-modal__layout">
      <h2 class="perfil-documento-modal__title" id="perfil-documento-modal-title">
        {{ config.title }}
      </h2>

      <ul class="perfil-documento-modal__tips">
        @for (tip of config.tips; track tip.text) {
        <li class="perfil-documento-modal__tip">
          <span class="perfil-documento-modal__tip-icon" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="8" r="8" fill="#00E5BE" />
              <path d="M4.5 8.2L6.7 10.4L11.5 5.6" stroke="#FFFFFF" stroke-width="1.6" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
          <p class="perfil-documento-modal__tip-text">
            <span>{{ tip.text }}</span>
            @if (tip.emph) {
            <strong>{{ tip.emph }}</strong>
            }
          </p>
        </li>
        }
      </ul>

      @if (hasSamples) {
      <div class="perfil-documento-modal__samples" aria-hidden="true">
        @for (ejemplo of config.samples; track ejemplo.id) {
        <div class="perfil-documento-modal__sample">
          @if (ejemplo.label) {
          <p class="perfil-documento-modal__sample-label">{{ ejemplo.label }}</p>
          }
          <div class="perfil-documento-modal__sample-imgs"
            [class.perfil-documento-modal__sample-imgs--single]="ejemplo.images.length === 1">
            @for (img of ejemplo.images; track img) {
            <img class="perfil-documento-modal__img" [src]="img" alt="" />
            }
          </div>
        </div>
        }
      </div>
      }

      <button type="button" class="perfil-documento-modal__cta" id="btn-perfil-documento-modal-subir"
        (click)="onSubir()">
        <span>{{ config.cta }}</span>
        <span class="material-icons perfil-documento-modal__cta-icon" aria-hidden="true">upload</span>
      </button>
    </div>
  </div>
</div>
}
